import React from 'react'
let PropTypes = React.PropTypes

import Modal from 'react-bootstrap/lib/Modal.js'
import { ReemplazoIMG } from './ReemplazoIMG.jsx'
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
import { ZoomImagenVencimiento } from './ZoomImagenVencimiento.jsx'

import classNames from 'classnames/bind'
import * as css from './Modales.css'
import { sincronizarDesdeFechaExp, sincronizarDesdeFechaVenc, validarFechaJuliano } from './fechasVencimiento.js'
let cx = classNames.bind(css)

// ---------------------------------------------------------------------------
// Conversión Fecha Vencimiento (fecha_exp) <-> Fecha Juliana (fecha_venc)
// Los helpers están en fechasVencimiento.js para compartirlos con RowCaptura.jsx
// ---------------------------------------------------------------------------

// Tipos de input en los que las flechas mueven el cursor/valor propio en lugar de navegar
const TIPOS_INPUT_CON_CURSOR = ['text', 'search', 'url', 'tel', 'email', 'password', 'number', 'date', 'time', 'datetime-local', 'month', 'week']

// true si el elemento es un campo donde las flechas deben editar texto/fecha
const esCampoEditable = (elemento)=>{
    if(!elemento){
        return false
    }
    if(elemento.isContentEditable || elemento.tagName === 'TEXTAREA'){
        return true
    }
    return elemento.tagName === 'INPUT' && TIPOS_INPUT_CON_CURSOR.indexOf(String(elemento.type || 'text').toLowerCase()) > -1
}

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = {visible: false}
        let self = this
        this.show = ()=>
            self.setState({visible: true})
        this.hide = ()=>{
            self.setState({visible: false})
        }
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalInformarResultado extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false
        }
        this.handleSubmit = (evt)=>{
            this.setState({bloqueado: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.setState(()=>{
                this.props.onClick()
                    .then(()=>{
                        this.setState({bloqueado: false})
                        this.props.hideModal()
                    })
                    .catch(error=>{
                        console.log("error")
                    })
            })
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Informar resultado de auditoría</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Se informarán los resultados de la auditoría por correo. ¿Está seguro de proceder con esta acción?.</p>
                </Modal.Body>
                <Modal.Footer>
                    <form onSubmit={this.handleSubmit}>
                        <button type={'submit'} className={'btn btn-primary'} disabled={this.state.bloqueado}>{'Informar'}</button>
                        <button type={'button'} className={'btn btn-secondary'} onClick={this.props.hideModal}>Cancelar</button>
                    </form>
                </Modal.Footer>
            </Modal>
        )
    }
}
ModalInformarResultado.contextTypes = {
}
//Confirmación de la eliminación de una captura (reemplaza el window.confirm que
//usaba la fila): muestra el mismo mensaje en un modal junto con el detalle de la
//captura que se invalidará. Mientras el backend responde los botones quedan
//bloqueados, para evitar un doble click.
//La eliminación tiene doble confirmación: el primer click en Eliminar no
//elimina, sólo muestra el texto de advertencia junto al botón y cambia su texto
//a Confirmar; recién ese segundo click invalida la captura.
//Se usa en las tres tablas del panel de revisión: vencimientos (RowVencimiento),
//IRD (RowIRD) y No Encontrados (RowNoEncontrado), cada una con su propio detalle
//y mensaje; en IRD/No Encontrados el id que se elimina es el de la captura de la
//fila, por eso el modal sólo confirma y delega en el onConfirmar de la fila.
export class ModalConfirmarEliminarCaptura extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false,
            confirmando: false
        }
        //El modal vive dentro de la fila de la tabla: si la lista se recarga
        //(por ejemplo al eliminar en No Encontrados) la fila se desmonta antes
        //de que responda el backend, así que no se debe tocar el estado después.
        this._montado = true
        //Primer click en Eliminar: no elimina, sólo pide la confirmación final
        this.pedirConfirmacion = (evt) => {
            evt.preventDefault()
            evt.stopPropagation()
            if (this.state.bloqueado || !this._montado) {
                return
            }
            this.setState({ confirmando: true })
        }
        //Segundo click (el botón ya dice Confirmar): aquí sí se elimina la captura
        this.confirmar = (evt) => {
            evt.preventDefault()
            evt.stopPropagation()
            if (this.state.bloqueado) {
                return
            }
            this.setState({ bloqueado: true }, () => {
                Promise.resolve(this.props.onConfirmar())
                    .then(() => {
                        //Si la fila ya no existe (lista recargada) no hay nada que actualizar
                        if (!this._montado) {
                            return
                        }
                        this.setState({ bloqueado: false })
                        this.props.hideModal()
                    })
                    .catch(error => {
                        console.log(error)
                        if (this._montado) {
                            this.setState({ bloqueado: false })
                        }
                    })
            })
        }
        //Texto del botón principal según el paso en que va la eliminación
        this._textoBoton = () =>
            this.state.bloqueado ? 'Eliminando...' : (this.state.confirmando ? 'Confirmar' : 'Eliminar')
        //Cancelar (o cerrar el modal) vuelve al primer paso, para que al abrirlo
        //nuevamente se pida otra vez la doble confirmación
        this._cancelar = (evt) => {
            if (evt) {
                evt.preventDefault()
                evt.stopPropagation()
            }
            if (!this._montado) {
                return
            }
            this.setState({ confirmando: false }, () => this.props.hideModal())
        }
    }
    componentWillUnmount() {
        this._montado = false
    }
    render() {
        let captura = this.props.capturaVencimiento || {}
        //Por defecto (capturas de vencimiento) se muestra el detalle de la captura;
        //las otras tablas (IRD y No Encontrados) pasan su propio arreglo de
        //{etiqueta, valor} para mostrar los campos que corresponden a su tabla.
        const detalle = this.props.detalle || [
            {etiqueta: 'SKU', valor: captura.sku},
            {etiqueta: 'Descriptor', valor: captura.descriptor},
            {etiqueta: 'Lote', valor: captura.lote},
            {etiqueta: 'Fecha Vencimiento', valor: captura.fecha_exp}
        ]
        return (
            <Modal show={true} onHide={this._cancelar} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.titulo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{this.props.mensaje}</p>
                    <div className={cx('detalleCaptura')}>
                        {detalle.map((fila, index)=>
                            <div key={index}><b>{fila.etiqueta}: </b>{fila.valor}</div>)}
                    </div>
                </Modal.Body>
                <Modal.Footer className={cx('pieEliminar')}>
                    {/* Segundo paso: el texto de advertencia aparece junto al botón Confirmar */}
                    {this.state.confirmando &&
                        <span className={cx('alertaConfirmar')}>{this.props.mensajeConfirmacion}</span>}
                    <button type={'button'} className={'btn btn-danger'} disabled={this.state.bloqueado}
                        onClick={this.state.confirmando ? this.confirmar : this.pedirConfirmacion}>
                        {this._textoBoton()}
                    </button>
                    <button type={'button'} className={'btn btn-default'} disabled={this.state.bloqueado} onClick={this._cancelar}>Cancelar</button>
                </Modal.Footer>
            </Modal>
        )
    }
}
ModalConfirmarEliminarCaptura.propTypes = {
    capturaVencimiento: PropTypes.object,
    //Detalle de la captura a eliminar: arreglo de {etiqueta, valor}. Si no se
    //envía se muestra el detalle de vencimientos (capturaVencimiento).
    detalle: PropTypes.array,
    titulo: PropTypes.string,
    mensaje: PropTypes.string,
    mensajeConfirmacion: PropTypes.string,
    // Metodos
    onConfirmar: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired
}
ModalConfirmarEliminarCaptura.defaultProps = {
    titulo: 'Eliminar captura',
    mensaje: '¿Está seguro de eliminar esta captura?',
    mensajeConfirmacion: '¿Está seguro de eliminar la captura?'
}
export class ModalRevisarVencimiento extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            index: 0,
            capturaVencimiento: [],
            capturaVencimientoRAW: [],
            error: '',
            reemplazos: [],
            showReemplazoImagen: false,
            primeraCaptura: false,
            ultimaCaptura: false,
            mostrarFotoDuracion: false
        }
        this.escFunction = this.escFunction.bind(this)
        this.focusFecha = this.focusFecha.bind(this)
        this.onInputChange = (key, evt)=>{
            let actualizado = {}
            actualizado[key] = evt.target.type === 'checkbox'? evt.target.checked : evt.target.value
            actualizado['editado'] = 1
            this.setState({ capturaVencimiento: Object.assign({}, this.state.capturaVencimiento, actualizado)})
        }
        //Guarda o limpia el mensaje de error de la Fecha Juliana. Los errores se
        //manejan con el mismo formato que devuelve el backend: {campo: [mensajes]}
        this.setErrorJuliano = (mensaje)=>{
            let errores = Object.assign({}, this.state.error)
            if(mensaje){
                errores.fecha_venc = [mensaje]
            }else{
                delete errores.fecha_venc
            }
            this.setState({error: errores})
        }
        //true si la Fecha Juliana escrita a mano quedó inválida.
        //La Fecha Vencimiento no se valida: al ser un input type="date" el navegador
        //sólo entrega fechas existentes y dentro de su rango permitido
        this.hayErrorJuliano = ()=> !!this.state.error.fecha_venc
        //Avisa y detiene la acción que persistiría la captura cuando la Fecha Juliana es inválida
        this.detenerPorJulianoInvalido = (accion)=>{
            if(!this.hayErrorJuliano()){
                return false
            }
            this.refs.notificator.error('Captura ' + (this.state.index+1), accion + '. Corrija la fecha juliana marcada', 5*1000)
            return true
        }
        //Captura a persistir: descarta la Fecha Juliana que no pasó la validación, de modo
        //que un valor que no es fecha nunca llegue a la base de datos
        this.capturaParaGuardar = ()=>{
            if(this.state.error.fecha_venc){
                let copia = Object.assign({}, this.state.capturaVencimiento)
                delete copia.fecha_venc
                return copia
            }
            return this.state.capturaVencimiento
        }
        //Al corregir la Fecha Vencimiento (date) se recalcula en simultáneo la Fecha Juliana (mes + año).
        //Este campo no requiere validación propia: type="date" sólo admite fechas existentes
        this.onFechaExpChange = (evt)=>{
            let actualizado = sincronizarDesdeFechaExp(evt.target.value)
            //Si la fecha elegida es válida la Fecha Juliana queda recalculada y su error previo ya no aplica
            if(actualizado.fecha_venc){
                this.setErrorJuliano(null)
            }
            this.setState({ capturaVencimiento: Object.assign({}, this.state.capturaVencimiento, actualizado)})
        }
        //Al corregir la Fecha Juliana (mes + año) se recalcula en simultáneo la Fecha Vencimiento (date)
        this.onFechaVencChange = (evt)=>{
            let mensaje = validarFechaJuliano(evt.target.value)
            this.setErrorJuliano(mensaje)
            //El texto escrito a mano se mantiene en el input (aunque esté incompleto o sea
            //inválido) para poder corregirlo, pero mientras haya error guardarCaptura y
            //handleSubmit quedan bloqueados; sincronizarDesdeFechaVenc sólo actualiza
            //fecha_exp cuando la Fecha Juliana es válida
            let actualizado = sincronizarDesdeFechaVenc(evt.target.value)
            this.setState({ capturaVencimiento: Object.assign({}, this.state.capturaVencimiento, actualizado)})
        }
        this.guardarCaptura = ()=>{
            if(this.detenerPorJulianoInvalido('No se guardó')){
                return false
            }
            if(this.state.capturaVencimiento.editado){
                this.context.actualizaCapturaVencimiento(this.capturaParaGuardar())
            }
            return true
        }
        //Captura que se muestra después de eliminar, restaurar o reemplazar una imagen: se
        //mantiene el índice actual sobre la lista ya recargada. Al eliminar la última captura
        //de la lista el índice queda fuera de rango, así que se apunta a la última disponible;
        //si ya no queda ninguna captura se cierra el modal, porque la captura que se estaba
        //revisando ya no existe y no hay nada que mostrar.
        this.setUPDVencimiento =()=>{
            const capturas = this.state.capturaVencimientoRAW || []
            if(!capturas.length){
                this.props.hideModal()
                return
            }
            const index = Math.min(this.state.index, capturas.length-1)
            //Al mostrar otra captura el error de la Fecha Juliana anterior ya no aplica y los
            //paneles de reemplazo/foto duración vuelven a su estado inicial, igual que al
            //navegar con las flechas (sus datos eran de la captura anterior)
            this.setState({
                index: index,
                primeraCaptura: index === 0,
                ultimaCaptura: index === capturas.length-1,
                capturaVencimiento: capturas[index],
                error: '',
                showReemplazoImagen: false,
                mostrarFotoDuracion: false
            })
        }
        this.setVencimiento =()=>{
            const captura = this.state.capturaVencimientoRAW[this.state.index]
            //Cambiar de imagen con las flechas no mueve el foco a los campos de captura:
            //la navegación y la edición de texto son independientes
            //Al mostrar otra captura el error de la Fecha Juliana anterior ya no aplica
            this.setState({capturaVencimiento: captura, error: ''})
        }
        this.capturaSiguiente =()=>{
            //Si la Fecha Juliana es inválida no se navega: primero debe corregirse
            if(!this.guardarCaptura()){
                return
            }

            this.setState({
                index: this.state.index<(this.state.capturaVencimientoRAW.length-1)? this.state.index+1 : this.state.index,
                primeraCaptura: false,
                ultimaCaptura: this.state.index<(this.state.capturaVencimientoRAW.length-1)? false : true,
                showReemplazoImagen: false,
                mostrarFotoDuracion: false
            },()=>this.setVencimiento())
        }
        this.capturaPrevia =()=>{
            //Si la Fecha Juliana es inválida no se navega: primero debe corregirse
            if(!this.guardarCaptura()){
                return
            }

            this.setState({
                index: this.state.index>0? this.state.index-1 : this.state.index,
                primeraCaptura: this.state.index>0? false : true,
                ultimaCaptura: false,
                showReemplazoImagen: false,
                mostrarFotoDuracion: false
            },()=>this.setVencimiento())
        }
        this.handleSubmit = ()=>{
            //No se guarda con una Fecha Juliana inválida escrita a mano (se indica bajo el campo)
            if(this.detenerPorJulianoInvalido('No se guardó')){
                return
            }
            if(this.state.capturaVencimiento.editado){
                this.context.actualizaCapturaVencimiento(this.capturaParaGuardar())
                    .then(()=>{
                        this.setState({
                            capturaVencimientoRAW: this.context.getVencimientos()
                        },()=>this.refs.notificator.success('Captura ' + (this.state.index+1), 'Actualizada correctamente', 4*1000))
                    })
                    .catch(err=>{
                        this.refs.notificator.error('Captura ' + (this.state.index+1), 'no actualizada', 4*1000)
                    })
            }
        }
        this.onCancel =()=>{
            this.props.hideModal()
        }
        this.hideReemplazo = ()=>{
            this.setState({showReemplazoImagen: false})
        }
        this.showReemplazoImagen=()=>{
            if(this.state.showReemplazoImagen){
                this.hideReemplazo()
            }else{
                this.context.getImagenesReemplazo(this.state.capturaVencimiento.idCapturaAuditoriaVencimiento, this.state.capturaVencimiento.sku, this.state.capturaVencimiento.lote, this.state.capturaVencimiento.fecha_exp)
                    .then(reemplazos=>{
                        this.setState({
                            reemplazos: reemplazos,
                            showReemplazoImagen: true
                        })
                    })
                    .catch(err=>{
                        console.log(err)
                        this.setState({
                            reemplazos: [],
                            showReemplazoImagen: true
                        })
                    })
            }
        }
        //Devuelve la promesa para que el modal de confirmación espere la respuesta del backend
        //antes de cerrarse (y así bloquea el doble click mientras se elimina)
        this.eliminarCaptura = ()=>{
            if(this.state.capturaVencimiento.editado){
                //Se persiste la captura sin la Fecha Juliana inválida (si la hubiera) antes de eliminarla
                
                return this.context.actualizaCapturaVencimiento(this.capturaParaGuardar())
                    .then(()=>{
                        this.setState({
                            capturaVencimientoRAW: this.context.getVencimientos()
                        },()=>
                            this.context.eliminarCapturaVencimiento(this.state.capturaVencimiento.idCapturaAuditoriaVencimiento)
                                .then(()=>{
                                    this.setState({
                                        capturaVencimientoRAW: this.context.getVencimientos()
                                    },()=>this.setUPDVencimiento())
                                })
                                .catch(()=>{
                                    this.refs.notificator.error('Captura ' + (this.state.index+1), 'no eliminada', 4*1000)
                                })
                        )
                    })
                    .catch(err=>{
                        this.refs.notificator.error('Captura ' + (this.state.index+1), 'no actualizada', 4*1000)
                    })
            }else{

                return this.context.eliminarCapturaVencimiento(this.state.capturaVencimiento.idCapturaAuditoriaVencimiento)
                .then(()=>{
                    this.setState({
                        capturaVencimientoRAW: this.context.getVencimientos()
                    },()=>this.setUPDVencimiento())
                })
                .catch(()=>{
                    this.refs.notificator.error('Captura ' + (this.state.index+1), 'no eliminada', 4*1000)
                })
            }
        }
        this.restaurarCaptura = ()=>{
            if(this.state.capturaVencimiento.editado){
                //Se persiste la captura sin la Fecha Juliana inválida (si la hubiera) antes de restaurarla
                this.context.actualizaCapturaVencimiento(this.capturaParaGuardar())
                    .then(()=>{
                        this.setState({
                            capturaVencimientoRAW: this.context.getVencimientos()
                        },()=>            
                            this.context.restaurarCapturaVencimiento(this.state.capturaVencimiento.idCapturaAuditoriaVencimiento)
                                .then(()=>{
                                    this.setState({
                                        capturaVencimientoRAW: this.context.getVencimientos()
                                    },()=>this.setUPDVencimiento())
                                })
                                .catch(err=>{
                                    console.log(err)
                                })
                        )
                    })
                    .catch(err=>{
                        this.refs.notificator.error('Captura ' + (this.state.index+1), 'no actualizada', 4*1000)
                    })
            }else{
                this.context.restaurarCapturaVencimiento(this.state.capturaVencimiento.idCapturaAuditoriaVencimiento)
                    .then(()=>{
                        this.setState({
                            capturaVencimientoRAW: this.context.getVencimientos()
                        },()=>this.setUPDVencimiento())
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }
        }
        this.reemplazarImagen=(idArchivoImagen)=>{
            this.context.reemplazarImagen(this.state.capturaVencimiento.idCapturaAuditoriaVencimiento, idArchivoImagen)
                .then(resp=>{
                    this.context.actualizaCapturaVencimiento(resp)
                        .then(()=>{
                            this.setState({capturaVencimientoRAW: this.context.getVencimientos()},()=>this.setUPDVencimiento())
                        })
                        .catch(()=>{})
                })
                .catch(err=>{
                    console.log(err)
                })
        }
        this.cambiarFoto=()=>{
            this.setState({
                mostrarFotoDuracion: !this.state.mostrarFotoDuracion
            })
        }
        this.onSubirImagen=(evt)=>{
            if (evt.target.files[0]){
                let file = evt.target.files[0]
                this.context.subirImagenVencimiento(this.state.capturaVencimiento.idCapturaAuditoriaVencimiento, file)
                    .then(resp=>{
                        this.context.actualizaCapturaVencimiento(resp)
                            .then(()=>{
                                this.setState({capturaVencimientoRAW: this.context.getVencimientos()}, ()=>this.setUPDVencimiento())
                            })
                            .catch(()=>{})
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }
        }
    }
    //Set Focus a Input de lote
    focusFecha() {
        this.fechaInput.focus();
    }
    escFunction(evt){
        //Si el foco está en un campo de captura (Fecha Vencimiento, Fecha Juliana, Lote, ...)
        //las flechas deben mover el cursor dentro del campo y no cambiar de imagen
        if(esCampoEditable(evt.target) || esCampoEditable(document.activeElement)){
            return
        }
        //Con teclas modificadoras las flechas conservan la función del navegador
        if(evt.altKey || evt.ctrlKey || evt.metaKey){
            return
        }
        //Flecha Izquierda Presionada
        //Reduce el index para mostar captura previa
        if (evt.keyCode===37){
            this.capturaPrevia()
        }
        //Flecha Derecha Presionada
        //Aumenta el index para mostar captura siguiente
        if(evt.keyCode===39){
            this.capturaSiguiente()
        }
    }
    componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
        this.focusFecha()
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
    }
    componentWillMount(){
        this.setState({
            index: this.props.index,
            primeraCaptura: this.props.index === 0? true : false,
            capturaVencimiento: this.props.capturaVencimiento,
            capturaVencimientoRAW: this.context.getVencimientos()
        })
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalVencimiento')} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Captura Venc. Local {this.props.local} Auditor {this.props.auditor}, {this.state.index+1} de {this.state.capturaVencimientoRAW.length}, ITEM {this.state.capturaVencimiento.items}, <span className={css.sku}>SKU {this.state.capturaVencimiento.sku}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <ReactNotify ref='notificator' className={ReactNotifyCSS} />
                        <div className="col-md-5 col-md-offset-1">
                            <div className="col-md-12">
                                <h5><strong>{this.state.capturaVencimiento.descriptor} Lab. {this.state.capturaVencimiento.laboratorio}</strong></h5>
                            </div>
                            <div className="col-md-12" style={{ textAlign: 'center' }}>
                                <ZoomImagenVencimiento
                                    ruta_imagen={this.state.capturaVencimiento.ruta_imagen[this.state.mostrarFotoDuracion ? 1 : 0].ruta}
                                />
                            </div>

                        </div>
                        <div className="col-md-5">

                            {/* Navegación */}
                            <div
                                className="col-md-12"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: 15
                                }}
                            >
                                <nav aria-label="Navegación de capturas">
                                    <ul
                                        className="pager"
                                        style={{
                                            margin: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8
                                        }}
                                    >
                                        <li>
                                            <a
                                                className={cx('btnPrevio')}
                                                style={{ userSelect: 'none' }}
                                                onClick={this.capturaPrevia}
                                            >
                                                {this.state.primeraCaptura
                                                    ? null
                                                    : <span
                                                        className="glyphicon glyphicon-arrow-left"
                                                        aria-hidden="true"
                                                    />
                                                }
                                                {this.state.primeraCaptura
                                                    ? " Primera Captura"
                                                    : " Previa"
                                                }
                                            </a>
                                        </li>

                                        <li>
                                            <a
                                                className={cx('btnSiguiente')}
                                                style={{ userSelect: 'none' }}
                                                onClick={this.capturaSiguiente}
                                            >
                                                {this.state.ultimaCaptura
                                                    ? "Última Captura "
                                                    : "Siguiente "
                                                }

                                                {this.state.ultimaCaptura
                                                    ? null
                                                    : <span
                                                        className="glyphicon glyphicon-arrow-right"
                                                        aria-hidden="true"
                                                    />
                                                }
                                            </a>
                                        </li>

                                        {this.state.capturaVencimiento.doble_foto === 1 && (
                                            <li>
                                                <a
                                                    className={cx('btnSiguiente')}
                                                    style={{ userSelect: 'none' }}
                                                    onClick={this.cambiarFoto}
                                                >
                                                    {this.state.mostrarFotoDuracion
                                                        ? 'Elaboración '
                                                        : 'Duración '
                                                    }

                                                    <span
                                                        className="glyphicon glyphicon-refresh"
                                                        aria-hidden="true"
                                                    />
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                </nav>
                            </div>


                            {/* Fecha de vencimiento */}
                            <div
                                className={cx('col-md-12 form-group', 'form__control-label')}
                                style={{ marginBottom: 12 }}
                            >
                                <label className="col-sm-4 control-label">
                                    Fecha Vencimiento
                                </label>

                                <div className="col-sm-4">
                                    <input
                                        ref={(input) => { this.fechaInput = input; }}
                                        type="text"
                                        className="form-control"
                                        placeholder="Fecha Juliana"
                                        id={this.state.index}
                                        disabled={this.props.fcv}
                                        value={this.state.capturaVencimiento.fecha_venc}
                                        onChange={this.onFechaVencChange}
                                    />

                                    {this.state.error.fecha_venc && (
                                        <span className={cx('form__error-message')}>
                                            {this.state.error.fecha_venc[0]}
                                        </span>
                                    )}
                                </div>

                                <div className="col-sm-4">
                                    <input
                                        type="date"
                                        className="form-control"
                                        placeholder="Fecha Vencimiento"
                                        id={this.state.index}
                                        value={this.state.capturaVencimiento.fecha_exp}
                                        onChange={this.onFechaExpChange}
                                        disabled={this.props.fcv}
                                        readOnly={true}
                                    />
                                </div>
                            </div>


                            {/* Lote */}
                            <div
                                className={cx('col-md-12 form-group', 'form__control-label')}
                                style={{ marginBottom: 12 }}
                            >
                                <label className="col-sm-4 control-label">
                                    Lote
                                </label>

                                <div className="col-sm-8">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Lote"
                                        id={this.state.index}
                                        disabled={this.props.fcv}
                                        value={this.state.capturaVencimiento.lote}
                                        onChange={this.onInputChange.bind(this, 'lote')}
                                    />

                                    {this.state.error.lote && (
                                        <span className={cx('form__error-message')}>
                                            {this.state.error.lote[0]}
                                        </span>
                                    )}
                                </div>
                            </div>


                            {/* Opciones */}
                            <div
                                className="col-md-12"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    flexWrap: 'wrap',
                                    gap: 16,
                                    marginBottom: 15
                                }}
                            >
                                <label
                                    style={{
                                        fontWeight: 'normal',
                                        fontSize: 12,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        margin: 0
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        disabled={this.props.fcv}
                                        checked={!!this.state.capturaVencimiento.malEnfocado}
                                        onChange={this.onInputChange.bind(this, 'malEnfocado')}
                                    />
                                    ¿Foto sin respaldo?
                                </label>

                                <label
                                    style={{
                                        fontWeight: 'normal',
                                        fontSize: 12,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        margin: 0
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        disabled={this.props.fcv}
                                        checked={!!this.state.capturaVencimiento.noMedible}
                                        onChange={this.onInputChange.bind(this, 'noMedible')}
                                    />
                                    ¿Sin expiración?
                                </label>

                                <label
                                    style={{
                                        fontWeight: 'normal',
                                        fontSize: 12,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        margin: 0
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        disabled
                                        checked={!!this.state.capturaVencimiento.vencido_politica}
                                        readOnly
                                    />
                                    ¿Fuera Política?
                                </label>
                            </div>


                            {/* Botones */}
                            <div
                                className="col-md-12"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: 8,
                                    marginBottom: 15
                                }}
                            >

                                {!this.props.fcv && (
                                    <button
                                        className={cx("btn btn-sm btn-primary", 'btnModal')}
                                        onClick={this.handleSubmit}
                                    >
                                        <span
                                            className="glyphicon glyphicon-floppy-disk"
                                            aria-hidden="true"
                                        />
                                        {' '}Guardar
                                    </button>
                                )}

                                {!this.props.fcv && (
                                    this.state.capturaVencimiento.estado === 3 ? (
                                        <button
                                            className={cx("btn btn-sm btn-info", 'btnModal')}
                                            onClick={this.restaurarCaptura}
                                        >
                                            <span
                                                className={"glyphicon glyphicon-share-alt " + css.iconoEspejo}
                                                aria-hidden="true"
                                            />
                                            {' '}Restaurar
                                        </button>
                                    ) : (
                                        <ModalTrigger>
                                            {(isVisible, showModal, hideModal)=>
                                                <div>
                                                    <button
                                                        className={cx("btn btn-sm btn-danger", 'btnModal')}
                                                        onClick={showModal}
                                                    >
                                                        <span
                                                            className="glyphicon glyphicon-remove"
                                                            aria-hidden="true"
                                                        />
                                                        {' '}Eliminar
                                                    </button>
                                                    {/* Doble confirmación antes de eliminar (igual que en la
                                                        tabla de vencimientos): el detalle por defecto muestra
                                                        SKU, descriptor, lote y fecha de vencimiento actuales */}
                                                    {isVisible && <ModalConfirmarEliminarCaptura
                                                        capturaVencimiento={this.state.capturaVencimiento}
                                                        onConfirmar={this.eliminarCaptura}
                                                        hideModal={hideModal}
                                                    />}
                                                </div>
                                            }
                                        </ModalTrigger>
                                    )
                                )}

                                {!this.props.fcv && (
                                    <button
                                        className={cx("btn btn-sm btn-info", 'btnModal')}
                                        onClick={this.showReemplazoImagen}
                                    >
                                        <span
                                            className="glyphicon glyphicon-random"
                                            aria-hidden="true"
                                        />
                                        {' '}Reemplazo
                                    </button>
                                )}

                                {!this.props.fcv && (
                                    <label
                                        htmlFor="subirFoto"
                                        style={{ margin: 0 }}
                                    >
                                        <li
                                            className={cx(
                                                "btn btn-sm btn-primary",
                                                'btnModal'
                                            )}
                                            title="Seleccionar Foto"
                                            style={{ listStyle: 'none' }}
                                        >
                                            <span
                                                className="glyphicon glyphicon-picture"
                                                aria-hidden="true"
                                            />
                                            {' '}Nueva
                                        </li>

                                        <input
                                            className={cx('inputFileReact')}
                                            id="subirFoto"
                                            type="file"
                                            onChange={this.onSubirImagen.bind(this)}
                                        />
                                    </label>
                                )}

                                <button
                                    className={cx(
                                        "btn btn-sm btn-cancel",
                                        'btnModal'
                                    )}
                                    onClick={this.onCancel}
                                >
                                    <span
                                        className="glyphicon glyphicon-remove-circle"
                                        aria-hidden="true"
                                    />
                                    {' '}Cerrar
                                </button>
                            </div>


                            {/* Reemplazo de imagen */}
                            {!this.props.fcv && this.state.showReemplazoImagen && (
                                <ReemplazoIMG
                                    posibles={this.state.capturaVencimiento.posibles}
                                    reemplazos={this.state.reemplazos}
                                    reemplazarImagen={this.reemplazarImagen}
                                    hideReemplazo={this.hideReemplazo}
                                />
                            )}

                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}
ModalRevisarVencimiento.contextTypes = {
    getVencimientos: PropTypes.func,
    actualizaCapturaVencimiento: PropTypes.func,
    getImagenesReemplazo: PropTypes.func,
    reemplazarImagen: PropTypes.func,
    capturaVencimientoMalEnfocada: PropTypes.func,
    eliminarCapturaVencimiento: PropTypes.func,
    restaurarCapturaVencimiento: PropTypes.func,
    subirImagenVencimiento: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/revision/Modales.jsx